export const WISHLIST_URL = '/api/proxy/wishlist';
export const REMOVE_FROM_WISHLIST_URL = '/api/proxy/wishlist/{{sku}}';
